export default __webpack_public_path__ + "static/media/1207.2b8312f9.jpg";